// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"imageEditionModal_imageContainer__LUE1s","buttonContainer":"imageEditionModal_buttonContainer__3lzFG"};